/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLocalStorageState, useRequest } from "ahooks";
import { SetState } from "ahooks/lib/createUseStorageState";

export function useAccessId() {
  const rtn = useLocalStorageState<string>(`accessId`, {
    defaultValue: "",
    listenStorageChange: true,
  });

  return rtn;
}

export function useToken() {
  const [accessId, setAccessId] = useAccessId();
  const rtn = useLocalStorageState<string | null>(`token/${accessId}`, {
    defaultValue: null,
    listenStorageChange: true,
  });

  return rtn;
}

export function useConfig() {
  const [accessId, setAccessId] = useAccessId();
  const rtn = useLocalStorageState<any>(`config/${accessId}`, {
    defaultValue: null,
    listenStorageChange: true,
  });

  return rtn;
}

export interface MessageProps {
  role: "user" | "assistant" | "system";
  content: string;
  id: string;
  /**
   * ISO
   */
  date: string;
  appId: string;
  appType: number;
  replyId?: string;
  sessionId?: string;
  // 额外参数
  isSendFail?: boolean;
}

export function useMessages(sessionId: string) {
  const [accessId, setAccessId] = useAccessId();
  const rtn = useLocalStorageState<MessageProps[]>(
    `messages/${accessId}/${sessionId}`,
    {
      defaultValue: [],
      listenStorageChange: true,
    }
  );

  return rtn;
}

export function useNewChatMessages() {
  const [accessId, setAccessId] = useAccessId();
  const rtn = useLocalStorageState<MessageProps[]>(
    `messages/${accessId}/new-chat`,
    {
      defaultValue: [],
      listenStorageChange: true,
    }
  );

  return rtn;
}

export function useCurrentApp() {
  const [accessId, setAccessId] = useAccessId();
  const rtn = useLocalStorageState(`currentApp/${accessId}`, {
    defaultValue: null,
    listenStorageChange: true,
  });

  return rtn;
}

export function useScrollToBottom() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, [location]);
}

export function usePageVisibility() {
  const [isPageVisible, setIsPageVisible] = useState(!document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsPageVisible(!document.hidden);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return isPageVisible;
}
